exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Basic editor styles */\n.ProseMirror > * + * {\n  margin-top: 0.75em;\n}", ""]);

// exports
